import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        position: "relative",
    },
    link: {
        position: "absolute",
        top: 0,
        right: 0,
        fontSize: theme.fontSizes.xs,
    },
}))
